import { makeRoute } from '~/utils/route';

export default makeRoute({
	path:        '/notifications/new',
	title:       'menu.notification-new',
	// @ts-ignore
	redirectTo:  () => {
		window.location.href = '/front5/notifications/new';
	},
});
